import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../app/environments/environment';
import { CompanyInfo } from '../shared/dto/models-dto';
import { SectorDto } from '../shared/dto/models-dto';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private http: HttpClient) {}

   getCompanies(): Observable<CompanyInfo[]> {
  return this.http.get<CompanyInfo[]>(`${environment.apiUrl}/api/companies/recently-created`);
}

    getCompanyFullDetails(id: number): Observable<any> {
    return this.http.get(`${environment.apiUrl}/api/trainees/full-details/${id}`);
  }

 getCountries(): Observable<any> {
  return this.http.get(`${environment.apiUrl}/api/countries/existing`);
}

getCities(): Observable<any> {
  return this.http.get(`${environment.apiUrl}/api/cities/existing`);
}

getSectors(): Observable<SectorDto[]> {
  return this.http.get<SectorDto[]>(`${environment.apiUrl}/api/companies/sectors`);
}


}
